import { useRef } from "react";
import { useForm } from "react-hook-form";
import Button from "../../../components/form-controls/Button";
import Input from "../../../components/form-controls/Input";
import { SubAccountService } from "../../../services/SubaccountService";
import useModal from "../../../hooks/useModal";
import { useTranslation } from "react-i18next";


interface ModalSubAccountProps {
    show: boolean;
    onRequestClose: (reload: boolean) => void;
    accountID: any;
}
function ModalAddSubAccount ({ show, accountID, onRequestClose }: ModalSubAccountProps){

    const { t } = useTranslation();

    const modalSubRef = useRef<HTMLDivElement>(null);

    useModal(modalSubRef, show)

    const defaultValues = {
       name: '',
       description: ''
    }

    const {register, handleSubmit, reset, formState: { errors, isValid, isSubmitting }} = useForm({
        mode: 'onChange',
        defaultValues
    });

    const closeAndReset = async(reload: boolean) => {
        await onRequestClose(reload);
        reset(defaultValues);
    }

    const submit = async(data) => {
        try {
            const sendData = { 
                account_id: accountID,
                name: data.name,
                description: data.description
            }

            await SubAccountService.createSubAccount(sendData);
            await closeAndReset(true);

        } catch (error) {
            console.log(error);
        }
    }

    return(
        <div className="modal fade" ref={modalSubRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">{t("config.subaccount.create-title")}</h4>
                        <button type="button" className="btn-close" onClick={() => closeAndReset(false) }></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <Input label= {t("config.subaccount.name-subaccount")} errors={errors.name} {...register('name', { required: true })} />
                        </div>
                        <div className="mb-3">
                            <Input label={t("config.subaccount.description-label")}  errors={errors.description} {...register('description', { required: true })} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-white btn-sm" onClick={() => closeAndReset(false)}>{t("btn-cancel")}</button>
                        <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting}>{t("btn-save")}</Button>
                    </div>
                    </div>
                </form>
            </div>
        </div>
    )

}


export default ModalAddSubAccount;